import { ConditionContainer } from '@dfl/mui-react-common';
import { CheckCircle, Cancel } from '@mui/icons-material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

type BooleanCellProps = {
  value: boolean;
  className?: string;
  text?: boolean;
  translationNs?: string;
};

const BooleanCell = ({ value, className, text, translationNs }: BooleanCellProps) => {
  const { t } = useTranslation(translationNs || 'banner');

  return (
    <ConditionContainer active={value} alternative={text ? t('withText.false') : <Cancel className={className} color={'error'} />}>
      {text ? t(`withText.${value?.toString()}`) : <CheckCircle className={className} color={'success'} />}
    </ConditionContainer>
  );
};

export default memo(BooleanCell);
